import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { rebuildSchema } from '@api/schemaConfig';

import { IRebuildSchema } from '@interfaces/cmModule/schemaConfig';
import { IOnSuccess } from '@interfaces/common/handlers';

import { ESnackbarTypes, EUserRoles } from '@enums/common';

import {
	MAVENIR_SCHEMA_CONFIG,
	SCHEMA_CONFIG_REBUILD,
} from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

interface ISchemaDeleteDeleteReturnType {
	rebuildSchemaConfig: (data: IRebuildSchema) => void;
	isLoadingRebuildSchemaConfig: boolean;
}

export function useMutateSchemaRebuild(
	props?: IOnSuccess,
): ISchemaDeleteDeleteReturnType {
	const dispatch = useAppDispatch();
	const queryClient = useQueryClient();

	const { onSuccess } = props || {};

	const {
		mutate: rebuildSchemaConfig,
		isLoading: isLoadingRebuildSchemaConfig,
	} = useMutation<IRebuildSchema>({
		mutationKey: [SCHEMA_CONFIG_REBUILD],
		mutationFn: async (data: IRebuildSchema) => {
			await rebuildSchema({ folderId: data.folderId });

			dispatch(setSnackbar({
				message: responseMessages.rebuildSchema(data.presetName),
				type: ESnackbarTypes.success,
			}));
		},
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleAdmin,
			EUserRoles.networkOperatorCmModuleEditor,
		],
		onSuccess: () => {
			if (onSuccess) onSuccess();

			return [queryClient.invalidateQueries([MAVENIR_SCHEMA_CONFIG])];
		},
	});

	return {
		rebuildSchemaConfig,
		isLoadingRebuildSchemaConfig,
	};
}
